import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './../fields.css';

const CheckboxField = ({ input, placeholder, checked, intl, hideErrors, meta: { touched, error, warning } }) => (
    <div className="checkbox-field no-select">
        <label id={(typeof placeholder === 'string' ? placeholder : intl.formatHTMLMessage(placeholder, placeholder.values)).replace(/\s/g, '')}>
            <i className="material-icons">{checked ? 'check_box' : 'check_box_outline_blank'}</i>
            {checked === undefined ? <input {...input} type="checkbox" /> : <input {...input} type="checkbox" checked={checked} />}
            <span
                dangerouslySetInnerHTML={{ __html: typeof placeholder === 'string' ? placeholder : intl.formatHTMLMessage(placeholder, placeholder.values) }}
            />
        </label>
        {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
    </div>
);

CheckboxField.defaultProps = {
    placeholder: '',
    meta: {},
    input: {}
};

CheckboxField.propTypes = {
    placeholder: PropTypes.any,
    meta: PropTypes.object,
    input: PropTypes.object
};

export default injectIntl(CheckboxField);



// WEBPACK FOOTER //
// ./src/components/fields/checkbox/index.jsx